import { connect } from "react-redux";

import AnswerResult from "components/answer/AnswerResult";

import history from "utils/history";

import {
  // attr edit dialog
  setAttrResult,
  openAttrEditDialog,
  closeAttrEditDialog,
  selectAttrItem,
  // basic edit dialog
  setBasicResult,
  openBasicEditDialog,
  closeBasicEditDialog,
  selectBasicItem,
  // addition edit dialog
  setAdditionResult,
  openAdditionEditDialog,
  closeAdditionEditDialog,
  selectAdditionItem,
  // 自由記入
  changeFreeCommentText,
  changeIsEditFreeCommnet1,
  changeIsEditFreeCommnet2
} from "redux/modules/answer/answerResult";

import {
  openConfirmDialog,
  closeConfirmDialog
} from "redux/modules/confirmDialog";
import { openErrorDialog } from "redux/modules/errorDialog";
import { openMessageDialog } from "redux/modules/messageDialog";

import axios from "axios";
import storage from "../../utils/storage";

const mapStateToProps = state => ({
  answerResult: state.answerResult,
  answerAttribute: state.answerAttribute,
  answerHeader: state.answerHeader,
  answerOther: state.answerOther
});

const mapDispatchToProps = (dispatch, ownProps) => ({
  showErrorDialog: () => {
    dispatch(openErrorDialog(new Error("invalidOperation")));
  },
  handleCompleteBtn: () => () => {
    const dialogData = {
      title: "確認",
      contentText: "回答結果を送信してアンケートを終了します。よろしいですか？",
      btnLabel: "はい",
      handleClick: () => {
        dispatch(closeConfirmDialog());
        const baseApiUrl = () => {
          const isDevelop = process.env.NODE_ENV === "development";
          return isDevelop ? `http://${window.location.hostname}:3001/api` : "/api";
        };
        const base = baseApiUrl();
        axios
          .patch(
            `${base}/${localStorage.getItem("previewRole")}/survey_detail_checked/${localStorage.getItem("previewSurveyId")}`,
            { token: storage.getToken() }
          );
        history.push("/complete", ownProps);
      }
    };

    dispatch(openConfirmDialog(dialogData));
  },
  handlePrevBtn: () => {
    setTimeout(() => ownProps.history.goBack());
  },
  // attr edit doalog
  openAttrEditDialog: surveyAttr => () => {
    dispatch(openAttrEditDialog(surveyAttr));
  },
  selectAttrItem: item => {
    dispatch(selectAttrItem(item));
  },
  submitAttrDialog: (surveyAttr, attrItem) => () => {
    dispatch(setAttrResult(surveyAttr, attrItem));
    dispatch(closeAttrEditDialog());
  },
  closeAttrEditDialog: () => {
    dispatch(closeAttrEditDialog());
  },
  // basic edit doalog
  openBasicEditDialog: question => () => {
    dispatch(openBasicEditDialog(question));
  },
  selectBasicItem: num => () => {
    dispatch(selectBasicItem(num));
  },
  submitBasicDialog: (question, num) => () => {
    dispatch(setBasicResult(question, num));
    dispatch(closeBasicEditDialog());
  },
  closeBasicEditDialog: () => {
    dispatch(closeBasicEditDialog());
  },
  // addition edit doalog
  openAdditionEditDialog: addition => () => {
    dispatch(openAdditionEditDialog(addition));
  },
  selectAdditionItem: choice => () => {
    dispatch(selectAdditionItem(choice));
  },
  submitAdditionDialog: (addition, choice) => () => {
    dispatch(setAdditionResult(addition, choice));
    dispatch(closeAdditionEditDialog());
  },
  closeAdditionEditDialog: () => {
    dispatch(closeAdditionEditDialog());
  },
  // 自由記入
  onChangeFreeCommentText1: text => {
    dispatch(changeFreeCommentText("freeComment1", text));
  },
  onChangeFreeCommentText2: text => {
    dispatch(changeFreeCommentText("freeComment2", text));
  },
  onChangeIsEditFreeCommnet1: (flg, text) => {
    if (text.length <= 400) {
      dispatch(changeIsEditFreeCommnet1(flg));
    } else {
      dispatch(
        openMessageDialog(
          `コメントは400字以内で入力してください。(現在${text.length}文字)`
        )
      );
    }
  },
  onChangeIsEditFreeCommnet2: (flg, text) => {
    if (text.length <= 400) {
      dispatch(changeIsEditFreeCommnet2(flg));
    } else {
      dispatch(
        openMessageDialog(
          `コメントは400字以内で入力してください。(現在${text.length}文字)`
        )
      );
    }
  }
});

export default connect(mapStateToProps, mapDispatchToProps)(AnswerResult);



// WEBPACK FOOTER //
// ./src/containers/preview/AnswerResultContainer.js